import * as MathHelper from '../utils/math-helper';
import * as DomHelper from '../utils/dom-helper';
import * as FaceHelper from '../utils/face-result-helper';

function updateTryOn( elements , land_mark  , debug ){

	// console.info('[try-on-update-begin]');

    let frame_elem = elements.frame;
    let left_temple_elem = elements.left_temple;
    let right_temple_elem = elements.right_temple;

    // ********* 缩放素材尺寸并保存 *********
    let user_img_size = land_mark.user_img_actual_size;

    if ( debug ) placeDebugPoints( elements , land_mark );

    // 首先根据当前比例缩放 眼镜 镜腿 图片
    let pd_pixel_width = FaceHelper.calculatePD(
            FaceHelper.calcPixelPosition( user_img_size , land_mark.ratio.eye_center.left ) ,
            FaceHelper.calcPixelPosition( user_img_size , land_mark.ratio.eye_center.right )
        );
    let asset_scale_ratio = ( pd_pixel_width * land_mark.pd_scale_ratio ) / frame_elem.width;
        DomHelper.scaleElement( frame_elem , asset_scale_ratio );
        DomHelper.scaleElement( left_temple_elem , asset_scale_ratio );
        DomHelper.scaleElement( right_temple_elem , asset_scale_ratio );

    // 必须在 矩阵变换前缓存 glass_actual_size 用来偏移眼镜
    let before_matrix_glass_actual_size = DomHelper.getElementSize( frame_elem );
    // ********* 缩放素材尺寸并保存 END *********

    // ********* 首先只放置镜框到中心位置 *********
    let frame_center_pos = land_mark.label_position.frame_center;

    DomHelper.placeElement(
        frame_elem ,
        frame_center_pos ,
        {
            x : - before_matrix_glass_actual_size.w / 2 ,
            y : - before_matrix_glass_actual_size.h / 2
        }
    );
    // ********* 首先只放置镜框到中心位置 END *********


    // ********* 根据头部数据相应的转动镜框 *********
    DomHelper.rotate3dElement(frame_elem,
        land_mark.label_position.pose.roll_angle  ,
        - land_mark.label_position.pose.pitch_angle  , // 这个仰角有时错的离谱
        - land_mark.label_position.pose.yaw_angle  ,
        land_mark.perspective
    );

    // 偏移眼镜 X 值 ，对齐眉心
    let glass_translate_x = FaceHelper.poseYawTranslate( land_mark.label_position.pose.yaw_angle , land_mark.head_center_radius );
    DomHelper.transformFunc( frame_elem , 'translateX' , glass_translate_x + 'px' );
    // 偏移眼镜 Y 值 ，对齐眉心
    let glass_translate_y = FaceHelper.poseYawTranslate( - land_mark.label_position.pose.pitch_angle , land_mark.head_center_radius );
    DomHelper.transformFunc( frame_elem , 'translateY' , glass_translate_y + 'px' );
    // ********* 根据头部数据相应的转动镜框 END *********


    // ********* 放置 缩放 斜切 镜腿 *********

    // 通过 眼镜图片 的 matrix3d 函数反求 眼镜接点变换后的 位置
    let glass_matrix_3d_array = DomHelper.getMatrix3dArray( frame_elem );

    // 放置左镜腿到 matrix变换后新位置
    let left_joint_pos = FaceHelper.calcGlassJointPosition( frame_center_pos , before_matrix_glass_actual_size , land_mark.ratio.frame_joint.left );
    let left_joint_new_matrix_pos = MathHelper.matrixNewPosition( frame_center_pos , left_joint_pos , glass_matrix_3d_array );
    let left_temple_actual_size = DomHelper.getElementSize( left_temple_elem );
    let left_temple_shift = FaceHelper.calcTempleShift( left_temple_actual_size , land_mark.ratio.temple_joint );
        DomHelper.placeElement( left_temple_elem , left_joint_new_matrix_pos , left_temple_shift );

    // 放置右镜腿到 matrix变换后新位置
    let right_joint_pos = FaceHelper.calcGlassJointPosition( frame_center_pos , before_matrix_glass_actual_size , land_mark.ratio.frame_joint.right );
    let right_joint_new_matrix_pos = MathHelper.matrixNewPosition( frame_center_pos , right_joint_pos , glass_matrix_3d_array );
    let right_temple_actual_size = DomHelper.getElementSize( right_temple_elem );
    let right_temple_shift = FaceHelper.calcTempleShift( right_temple_actual_size , land_mark.ratio.temple_joint );
        DomHelper.placeElement( right_temple_elem , right_joint_new_matrix_pos , right_temple_shift );

    // 这里应要先固定镜腿的高度 , 缩放镜腿宽度
    DomHelper.setElementHeight( left_temple_elem , left_temple_actual_size.h );
    DomHelper.setElementHeight( right_temple_elem , right_temple_actual_size.h );

    let contour_ear_pos = {
        left : FaceHelper.calcPixelPosition( user_img_size , land_mark.ratio.contour_ear.left ) ,
        right : FaceHelper.calcPixelPosition( user_img_size , land_mark.ratio.contour_ear.right )
    };

    // 计算眼镜接点 与 耳部 接点的长度 压缩镜腿
    DomHelper.setElementWidth( left_temple_elem , calcScalarDistance( left_joint_new_matrix_pos.x , contour_ear_pos.left.x ) );
    DomHelper.setElementWidth( right_temple_elem , calcScalarDistance( right_joint_new_matrix_pos.x , contour_ear_pos.right.x ) );

    // skew 镜腿
    skewTemple( left_temple_elem , left_joint_new_matrix_pos , contour_ear_pos.left , land_mark );
    skewTemple( right_temple_elem , right_joint_new_matrix_pos , contour_ear_pos.right , land_mark );

    // ********* 放置 缩放 斜切 镜腿 END *********

    // 修正用户图片 absolute 居中后素材的偏移
    let user_img_elem = elements.user;
    DomHelper.fixAbsoluteShift( frame_elem , user_img_elem);
    DomHelper.fixAbsoluteShift( right_temple_elem , user_img_elem);
    DomHelper.fixAbsoluteShift( left_temple_elem , user_img_elem);

}

function placeDebugPoints( elements , land_mark ){

    let left_eye = elements.left_eye;
    let right_eye = elements.right_eye;

    let user_img_size = land_mark.user_img_actual_size;

    DomHelper.placeElement( left_eye , FaceHelper.calcPixelPosition( user_img_size , land_mark.ratio.eye_center.left ) );
    DomHelper.placeElement( right_eye , FaceHelper.calcPixelPosition( user_img_size , land_mark.ratio.eye_center.right ) );

    let user_img_elem = elements.user;
    DomHelper.fixAbsoluteShift( left_eye , user_img_elem);
    DomHelper.fixAbsoluteShift( right_eye , user_img_elem);

    console.log( MathHelper.calculatePositionAngle(
        FaceHelper.calcPixelPosition( user_img_size , land_mark.ratio.eye_center.right ) ,
        FaceHelper.calcPixelPosition( user_img_size , land_mark.ratio.eye_center.left )
    ) , 'pixel' );
}

function calcScalarDistance( x_a , x_b ) {
    return MathHelper.euclideanDistance( { x : x_a , y : 0 } , { x : x_b , y : 0 } );
}

function skewTemple( temple_elem , joint_new_matrix_pos , ear_position , land_mark ) {

    let temple_skew_y = MathHelper.calculatePositionAngle(  ear_position , joint_new_matrix_pos );
    let temple_skew_x = - land_mark.label_position.pose.roll_angle * Math.PI / 180 ;

    let should_reverse = scalePosNeedReverse( joint_new_matrix_pos , ear_position );
    let temple_scale_x = should_reverse ? -1 : 1;

    DomHelper.skewElement( temple_elem ,
        { x : temple_skew_x  , y : temple_skew_y } ,
        { x : temple_scale_x , y : 1 }
    );

}

function scalePosNeedReverse( joint_pos , contour_pos ) {
    return joint_pos.x  - contour_pos.x  > 0;
}

export default updateTryOn;
